import React from 'react';
import { FaHeart } from 'react-icons/fa';
import { PaperDarkBG, PaperGradientBG } from "../kits/DesignKit";
import UnderlineSketch from './UnderlineSketch';

function SectionZen() {
  return (
    <PaperGradientBG
  
    >
      <section className="py-16 sm:py-20 md:py-24">
        <div className="container mx-auto text-center px-6 max-w-4xl">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-mono text-amber-100 mb-6 leading-relaxed">
         
          
            <span className="text-brand relative inline-block">
              Softwarelösungen
          
            </span>
          </h1>
             <span className="text-brand relative inline-block">
              ZenDev
            
            </span>
          <p className="text-sm sm:text-base font-mono text-amber-100 italic mt-4 flex flex-wrap items-center justify-center gap-2 text-center">
            by Denis Bitter mit <FaHeart className="text-brand" aria-hidden="true" /> für Entwickler und Anwender
          </p>
        </div>
      </section>
    </PaperGradientBG>
  );
}

export default SectionZen;
